import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";

import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedPage from "../components/AnimatedPage";

function Profile() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [profit, setProfit] = useState(null);
    const [percent, setPercent] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const getProfileData = useCallback(() => {
        setIsRefreshing(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                setTimeout(() => setIsRefreshing(false), 500);
            })
            .catch((err) => {
                localStorage.removeItem("user");
                setIsRefreshing(false);
            });
    }, [profile]);

    useEffect(() => {
        getProfileData();
        axios.get(`${process.env.REACT_APP_API_URL}/profit/get`, {}).then((res) => {
            setProfit(res.data.data[0]);
        });
    }, []);

    useEffect(() => {
        if (profile && profit) {
            const phantram = profile.tongnap / profit["nap" + (profile.level + 1)];
            setPercent(phantram * 100 > 100 ? 100 : Math.round(phantram * 100));
        }
    }, [profit, profile]);

    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("currentUser");
        localStorage.removeItem("profile");
        localStorage.removeItem("data");
        localStorage.removeItem("data1");
        document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        navigate("/login");
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#fff", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                body { background-color: #fff; margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
                a { text-decoration: none; color: inherit; }
                
                .prof-container {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px;
                    display: flex; flex-direction: column; background: #fff; 
                    z-index: 10;
                    overflow-y: auto; overflow-x: hidden;
                }
                .prof-container::-webkit-scrollbar { display: none; }
                .prof-container { -ms-overflow-style: none; scrollbar-width: none; }

                /* HEADER TỐI MÀU PHÍA TRÊN */
                .p-dark-header {
                    background: linear-gradient(135deg, #3d342b 0%, #1a1a1a 100%);
                    height: 220px; width: 100%; position: absolute; top: 0; left: 0; z-index: 1;
                    border-bottom-left-radius: 50px;
                }
                
                /* THANH ĐIỀU HƯỚNG TRONG HEADER */
                .p-nav {
                    display: flex; justify-content: space-between; align-items: center;
                    padding: 15px 20px; color: #fff; position: relative; z-index: 2;
                }
                .p-nav-title { font-size: 18px; font-weight: 600; }
                .p-back-btn { cursor: pointer; display: flex; align-items: center; }

                /* NỘI DUNG CHÍNH CUỘN LÊN ĐÈ VÀO HEADER */
                .p-content {
                    position: relative; z-index: 2; padding: 0 15px; margin-top: 10px;
                }

                /* THẺ PROFILE (CARD BẠC/XANH NHẠT) */
                .p-card {
                    background: linear-gradient(135deg, #e3f2fd 0%, #f4f7f6 100%);
                    border-radius: 16px; padding: 20px 15px;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.1); position: relative; overflow: hidden;
                }
                /* Hình ngôi sao mờ lớn trang trí góc phải */
                .p-card-bg-icon {
                    position: absolute; right: -10px; top: 10px; opacity: 0.1; width: 140px; height: 140px; pointer-events: none; fill: #607d8b;
                }

                .p-card-top { display: flex; align-items: center; position: relative; z-index: 2;}
                .p-avatar {
                    width: 70px; height: 70px; border-radius: 50%; border: 3px solid #fff;
                    object-fit: cover; box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                }
                
                .p-info { margin-left: 15px; display: flex; flex-direction: column; justify-content: center; }
                .p-vip-tag {
                    background: linear-gradient(90deg, #606c88 0%, #3f4c6b 100%);
                    color: #fff; font-size: 10px; font-weight: bold; padding: 2px 8px;
                    border-radius: 12px; display: inline-flex; align-items: center; width: max-content;
                    margin-bottom: 5px; gap: 4px;
                }
                .p-username { font-size: 16px; font-weight: bold; color: #333; margin-bottom: 4px; display: flex; align-items: center; gap: 5px;}
                .p-nickname { font-size: 13px; color: #666; margin-bottom: 2px; display: flex; align-items: center; gap: 5px;}
                .p-date { font-size: 12px; color: #888; }

                /* HÀNG SỐ DƯ */
                .p-balance-row {
                    display: flex; justify-content: space-between; align-items: center;
                    margin-top: 20px; position: relative; z-index: 2;
                }
                .p-balance { font-size: 24px; font-weight: 800; color: #2c5282; }
                .p-refresh { cursor: pointer; color: #888; }
                .p-refresh svg { transition: transform 0.5s; width: 22px; height: 22px; }
                .p-refresh.spin svg { transform: rotate(360deg); }

                /* 3 NÚT RÚT/NẠP/THẺ MÀU TRẮNG ĐỔ BÓNG NỔI RÕ RÀNG HƠN */
                .p-btn-row {
                    display: flex; justify-content: space-between; gap: 12px; margin-top: 20px; position: relative; z-index: 2;
                }
                .p-btn {
                    flex: 1; background: #fff; border: none; border-radius: 20px;
                    padding: 12px 0; text-align: center; font-size: 14px; font-weight: 700; color: #4a5568;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15); /* Tăng bóng đổ rõ rệt */
                    cursor: pointer; transition: 0.2s;
                }
                .p-btn:active { background: #f7fafc; transform: translateY(2px); box-shadow: 0 2px 5px rgba(0,0,0,0.1); }

                /* DANH MỤC LƯỚI (GRID) BÊN DƯỚI */
                .p-menu-container { margin-top: 30px; padding: 0 5px; }
                
                .p-menu-header { position: relative; border-bottom: 1px solid #f0f0f0; margin-bottom: 25px; }
                .p-menu-tag {
                    background: #f0f0f0; display: inline-block; padding: 4px 12px; border-radius: 12px;
                    font-size: 12px; font-weight: 600; color: #555; position: absolute; top: -14px; left: 0;
                }

                .p-grid {
                    display: grid; grid-template-columns: repeat(4, 1fr); gap: 25px 10px;
                }
                .p-grid-item {
                    display: flex; flex-direction: column; align-items: center; cursor: pointer;
                }
                
                /* TĂNG KÍCH THƯỚC VÀ ĐỔ BÓNG CHO ICON VÀNG KIM DẠNG 3D */
                .p-grid-icon-wrap {
                    width: 58px; height: 58px; border-radius: 50%; border: none;
                    display: flex; justify-content: center; align-items: center;
                    background: linear-gradient(145deg, #fdfbf5 0%, #f4eacc 100%); 
                    margin-bottom: 10px; color: #cba361; transition: 0.2s;
                    box-shadow: 0 6px 12px rgba(203, 163, 97, 0.35), inset 0 -3px 5px rgba(0,0,0,0.08); /* Bóng đổ 3D cực rõ */
                }
                .p-grid-item:active .p-grid-icon-wrap { transform: translateY(3px); box-shadow: 0 2px 5px rgba(203, 163, 97, 0.2), inset 0 -1px 2px rgba(0,0,0,0.05); }
                .p-grid-text {
                    font-size: 12px; color: #555; text-align: center; line-height: 1.3;
                    max-width: 100%; word-break: break-word; font-weight: 600;
                }
            `}} />

            {profile && (
            <div className="prof-container">
                <div className="p-dark-header"></div>

                <div className="p-nav">
                    <div className="p-back-btn" onClick={() => navigate("/")}>
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="#fff"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                    </div>
                    <div className="p-nav-title">Thông tin</div>
                    <div style={{width: 24}}></div>
                </div>

                <div className="p-content">
                    <div className="p-card">
                        <svg className="p-card-bg-icon" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
                        
                        <div className="p-card-top">
                            <img alt="Avatar" src={profile.avatar || "https://i.ibb.co/5WDK50Gs/image.png"} className="p-avatar" />
                            <div className="p-info">
                                <div className="p-vip-tag">
                                    <svg viewBox="0 0 24 24" width="12" height="12" fill="#fff"><path d="M12 2L1 21h22L12 2zm0 3.5l6.5 12h-13L12 5.5z"/></svg>
                                    VIP{profile.level || 0}
                                </div>
                                <div className="p-username">
                                    {profile.username}
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="#444" style={{cursor:'pointer'}}><path d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8C6.9 5 6 5.9 6 7v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                                </div>
                             
                            </div>
                        </div>

                        <div className="p-balance-row">
                            {/* DÒNG TIỀN ĐÃ ĐƯỢC GIỮ ĐÚNG FORMAT VND CỦA BẠN SỬA */}
                            <div className="p-balance">
                                {parseFloat(profile.money || 0).toLocaleString("vi-VN")} VND
                            </div>
                            <div className={`p-refresh ${isRefreshing ? "spin" : ""}`} onClick={getProfileData}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="23 4 23 10 17 10"></polyline>
                                    <polyline points="1 20 1 14 7 14"></polyline>
                                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                                </svg>
                            </div>
                        </div>

                        <div className="p-btn-row">
                            <div className="p-btn" onClick={() => navigate("/recharge/bank")}>Nạp Tiền</div>
                            <div className="p-btn" onClick={() => navigate("/withdraw")}>Rút Tiền</div>
                            <div className="p-btn" onClick={() => navigate("/my/wallet")}>Thẻ của tôi</div>
                        </div>
                    </div>

                    <div className="p-menu-container">
                        <div className="p-menu-header">
                            <div className="p-menu-tag">Tài khoản của Tôi</div>
                        </div>

                        <div className="p-grid">
                            
                            {/* ĐÃ TRẢ LẠI CHUẨN CÁC LINK CỦA BẠN (CÓ CHỨA PROMO, PASS2, TRANSFERGAME) */}
                            <GridItem label="Khuyến mãi" to="/promo" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1h-4v-2h4zM9 4c.55 0 1 .45 1 1v2H6c0-.55.45-1 1-1s1 .45 1 1h1V4zM4 8h16v11H4V8zm8 2v9h-2v-9h2z"/></svg>} />
                            
                            <GridItem label="Chuyển quỹ game" to="/transfergame" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/></svg>} />
                            
                            <GridItem label="Lịch sử đặt cược" to="/historyplay" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"/></svg>} />
                            
                            {/* Icon Nạp tiền: Mũi tên hướng xuống khay */}
                            <GridItem label="Lịch sử nạp tiền" to="/transaction/history" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9h-2V7h-2v5H6l4 4 4-4h-2z"/></svg>} />
                            
                            {/* Icon Rút tiền: Mũi tên hướng lên khỏi khay */}
                            <GridItem label="Lịch sử rút tiền" to="/transaction/history" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8l-4-4-4 4h2v5h4v-5h2z"/></svg>} />

                            <GridItem label="Lịch sử giao dịch" to="/transaction/history" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>} />

                            <GridItem label="Lịch sử lãi lỗ" to="/history" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"/></svg>} />
                            
                            <GridItem label="Thông tin cá nhân" to="/password" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>} />
                            
                            <GridItem label="Mật khẩu rút tiền" to="/pass2" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>} />
                            
                            <GridItem label="Đại lý" to="/invite" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>} />
                            
                            <GridItem label="Tải ứng dụng" to="#" icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>} />

                            <GridItem label="Đăng xuất" onClick={handleLogout} icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>} />
                            
                        </div>
                    </div>
                </div>
            </div>
            )}
            
        </div>
    );
}

function GridItem({ icon, label, to, onClick }) {
    const navigate = useNavigate();
    const handleClick = () => {
        if (onClick) onClick();
        else if (to) navigate(to);
    };

    return (
        <div className="p-grid-item" onClick={handleClick}>
            <div className="p-grid-icon-wrap">
                {icon}
            </div>
            <div className="p-grid-text">{label}</div>
        </div>
    );
}

export default Profile;